import React from 'react'
import Container from 'react-bootstrap/Container';
import Row from 'react-bootstrap/Row';
import Col from 'react-bootstrap/Col';
import Card from 'react-bootstrap/Card';
import car1 from '../asset/car1.png';
import car2 from '../asset/car2.jpg';
import car3 from '../asset/car3.png';
import car4 from '../asset/car4.jpg'
import Contacts from './contacts';

export default function Pricing() {
  return (
    <>
        <div className='Price-BG'>
            <Container className='price'>
                <br />
                <div className='head'>
                <h1 color='ghostwhite'>PRICING</h1>
                </div>
                <br />
                <br />
                <Row xs={1} md={2}>
                <Col><Card style={{ width: '25rem' , height:'26.5rem' }}>
                <Card.Img variant="top" src={car1} />
                <Card.Body>
                <Card.Title>Bentley Bentayga EWB Mulliner</Card.Title>
                <Card.Text>
                    ENGINE : 4.0L/542-hp/568-lb-ft direct-injected turbocharged DOHC 32-valve V-8
                </Card.Text>
                <h5>INR 2,76,30,000.00</h5>
                </Card.Body>
            </Card></Col>
                <Col><Card style={{ width: '25rem', height: '26.5rem' }}>
                <Card.Img variant="top" src={car2} />
                <Card.Body>
                <Card.Title>CONTINENTAL GT MULLINER</Card.Title>
                <Card.Text>
                    ENGINE : twin-turbocharged 6.0 litre W12 petrol engine
                </Card.Text>
                <h5>INR 7,49,00,000.00</h5>
                </Card.Body>
            </Card></Col>        
                </Row>
                <br />
                <br />
                <Row xs={1} md={2}>
                <Col><Card style={{ width: '25rem' , height: '26.5rem' }}>
                <Card.Img variant="top" src={car3} />
                <Card.Body>
                <Card.Title>CONTINENTAL GTC SPEED</Card.Title>
                <Card.Text>
                    ENGINE : twin-turbocharged 6.0 litre W12 petrol engine
                </Card.Text>
                <h5>INR 4,04,00,000.00</h5>
                </Card.Body>
            </Card></Col>
                <Col><Card style={{ width: '25rem' , height:'26.5rem'}}>
                <Card.Img variant="top" src={car4} />
                <Card.Body>
                <Card.Title>CONTINENTAL GT</Card.Title>
                <Card.Text>
                    ENGINE : twin-turbocharged petrol engines: a 4.0 litre V8
                </Card.Text>
                <h5>INR 1,92,72,427.00</h5>
                </Card.Body>
            </Card></Col>        
                </Row>
                <br />
            </Container>
        </div>    
        <Contacts/>
    </>    
  )
}
